import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useNavigate } from "react-router-dom";

// Turn bare LR / invoice numbers into clickable links that open the matching list,
// filtered to that record. GARV is told to write numbers in full so this catches them.
const LR_RE = /(?<!\]\()\bLR[-\s]?\d[\d\w-]*/gi;
const INV_RE = /(?<!\]\()\bINV[-\s]?\d[\d\w-]*/gi;

function linkify(text) {
  if (!text) return "";
  let out = text.replace(LR_RE, (m) => `[${m}](/lrs?q=${m.replace(/[^0-9]/g, "")})`);
  out = out.replace(INV_RE, (m) => `[${m}](/invoices?q=${m.replace(/[^0-9]/g, "")})`);
  return out;
}

export function GarvMarkdown({ text }) {
  const navigate = useNavigate();
  const md = linkify(text || "");
  return (
    <div className="garv-md text-sm leading-relaxed break-words" data-testid="garv-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => {
            const internal = href && href.startsWith("/");
            return (
              <a href={href}
                 onClick={(e) => { if (internal) { e.preventDefault(); navigate(href); } }}
                 target={internal ? undefined : "_blank"} rel={internal ? undefined : "noreferrer"}
                 className="text-[#C84B31] underline underline-offset-2 hover:opacity-80 font-medium">
                {children}
              </a>
            );
          },
          table: ({ children }) => <div className="overflow-x-auto my-1"><table className="w-full text-xs border-collapse">{children}</table></div>,
          th: ({ children }) => <th className="border border-[#E5E3DB] px-2 py-1 text-left bg-[#EFEDE6] font-semibold">{children}</th>,
          td: ({ children }) => <td className="border border-[#E5E3DB] px-2 py-1 align-top">{children}</td>,
          ul: ({ children }) => <ul className="list-disc pl-4 space-y-0.5 my-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-4 space-y-0.5 my-1">{children}</ol>,
          p: ({ children }) => <p className="my-1 first:mt-0 last:mb-0">{children}</p>,
          h1: ({ children }) => <p className="font-semibold my-1">{children}</p>,
          h2: ({ children }) => <p className="font-semibold my-1">{children}</p>,
          h3: ({ children }) => <p className="font-semibold my-1">{children}</p>,
          code: ({ children }) => <code className="bg-[#E5E3DB] px-1 rounded text-[11px]">{children}</code>,
        }}
      >
        {md}
      </ReactMarkdown>
    </div>
  );
}
